/**
 * Calculate the width of the text
 * @param text
 * @param font
 * @returns {number}
 */
function getTextWidth(text, font) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
}

export default {
  methods: {
    truncateString(text, maxWidth, font = '16px Arial') {
      if (!text) return '';
      if (getTextWidth(text, font) <= maxWidth) return text;

      let start = 0, end = text.length;
      let truncatedText = text;

      while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        truncatedText = text.slice(0, mid) + '...';
        const width = getTextWidth(truncatedText, font);

        if (width > maxWidth) {
          end = mid - 1;
        } else {
          start = mid + 1;
        }
      }

      return truncatedText;
    },
    truncateHtmlText(value, limit = 380) {
      if (!value) return '';

      const text = value.replace(/<[^>]*>/g, '');
      return text.length > limit ? text.slice(0, limit) + '...' : text;
    }
  }
};
